import React, { useState ,useEffect} from 'react';
import { cloneDeep } from 'lodash';
import { ToastContainer } from "react-toastify";
import SearchContracts from './components/SearchContracts';
import { Card, CardBody, Container } from 'reactstrap';
import ContractTable from './components/ContractTable';
import useAxios from 'hooks/useAxios';
import ErrorBoundary from 'components/ErrorBoundary';
import useContextService from 'hooks/useContextService';
import { onExport, getUpdatedFilterLatest } from 'utils/helper';

let filters = [];

const Contracts = () => {
  const API = useAxios();
  const [data, setData] = useState([]);
  const[loading,setLoading]=useState(false);
  const [totalItem, setTotalItem] = useState(0);
  const {
    states: { contracts },
    setStates,
  } = useContextService();
  const { search,thirdPartyAdmin, searchTerms } = contracts;
  const { thirdPartyAdminID } = thirdPartyAdmin;
  const [enableAdd, setEnableAdd] = useState(true);
  const [collapseSider, setcollapseSider] = useState(false);

  useEffect(() => {
    if (searchTerms.thirdPartyAdminID){
      handleSearch(searchTerms);
      setEnableAdd(false);
    } 
  }, []);

  const handleExport = async () => {
    const { access_token } =
      JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
    const action = `${process.env.REACT_APP_ENDPOINT}/GWConfig/Contracts/ExportAll/${searchTerms.thirdPartyAdminID|| 0 }?access_token=${access_token}`;
    onExport(action, search);
  };

  const fetchContractsList = async (filters) => {
    setLoading(true);
    if (!thirdPartyAdminID) return null;
    try {
      const { data } = await API.post(`GWConfig/Contracts/All/${searchTerms.thirdPartyAdminID|| 0 }`, filters, {
        hasDefaultURL: true,
      });
      if (data) {
        setData(data.items);
        setTotalItem(data.totalRecords);
        setLoading(false);
      } else {
        setData([]);
        setTotalItem(0);
        setLoading(false);
      }
    } catch (error) { 
      setLoading(false);}
  };

  const handleSearch = async (filter) => {
    const {
      thirdPartyAdminID,
      pharmacyID,
      coveredEntityID,
      pharmacyIDs,
      coveredEntityIDS
    } = filter;
    Object.keys(filter).map((key) => {
      const index = filters.findIndex(
        (item) => item.filterName === key && key != 'dateofservice'
      );
      filters.splice(index, 1);
    });
    if (thirdPartyAdminID) {
      filters = getUpdatedFilterLatest(
        'ThirdPartyAdminID',
        parseInt(thirdPartyAdminID),
        filters
      );
      setEnableAdd(false);
    }

    var phIds = [];
    if (pharmacyIDs === undefined && searchTerms.pharmacyids.length !== undefined && searchTerms.pharmacyids.length > 0) {
      phIds = Array.isArray(filter.pharmacyids)
    ? filter.pharmacyids.map(item => item["value"])
    : [];
    }
    else {
      phIds = pharmacyIDs;
    }
    var covids = [];
    if (coveredEntityIDS === undefined && searchTerms.ceIds.length !== undefined && searchTerms.ceIds.length > 0) {
      covids = Array.isArray(filter.ceIds)
      ? filter.ceIds.map(item => item["value"])
      :[];
    }
    else {
      covids = coveredEntityIDS;
    }

    if (coveredEntityID) {
      filters = getUpdatedFilterLatest(
        'CEID',
        parseInt(coveredEntityID),
        filters
      );
    }
    if (pharmacyID) {
      filters = getUpdatedFilterLatest('PHID', pharmacyID, filters);
    }
    const tableRes = document.querySelector('.table-responsive');
    tableRes.scrollLeft = 0;
    search.filters = filters;    
    search.pharmacyIDs = phIds;
    search.coveredEntityIDS = covids;
    await fetchContractsList(search);
  };

  const refetch = () => {
    handleSearch(searchTerms);
  };

  
  const handlePageChange = (filter, haveColFilter) => {
    if (haveColFilter) {
      fetchContractsList(filter);
    } else {
      fetchContractsList(filter);
    }
    contracts.search = { ...contracts.search, ...filter };
    setStates('contracts', contracts);
  };

  const handleReset = () => {
    setData([]);
    setEnableAdd(true);
    setTotalItem(0);
    
  };

  const handleSearchColumnFilters = async (columnFilters) => {
    const filterObj = cloneDeep(search);
    filterObj.filters = [...filterObj.filters, ...columnFilters];
    await fetchContractsList(filterObj);
  };

  const toggleSider = () => {
    setcollapseSider(!collapseSider);
    if (!collapseSider) {
      setCollIcon(faAngleDown);
    } else {
      setCollIcon(faAngleUp);
    }
  };

  return (
    <div>
       <Container fluid className="width_info">
      <div className={collapseSider ? "mb-0" : "mb-3"}>
        <Card className="border-0 shadow-top">
          <CardBody  hidden={collapseSider} className="">
            <ErrorBoundary>
              <SearchContracts   refetch={refetch} onReset={handleReset} onSearch={handleSearch}    enableAdd={enableAdd}  />
              </ErrorBoundary>
          </CardBody>
          </Card>
          </div>
          <Card className="border-0 shadow-top">
          <CardBody className="">
            <ErrorBoundary> 
              <ContractTable
                data={data}
                //loading={loading}
                filters={search}
                totalSize={totalItem}
                thirdPartyAdmin={thirdPartyAdmin}
                onExport={handleExport}
                refetch={refetch}
                enableAdd={enableAdd}
                onPageChange={handlePageChange}
                onSearchColumnFilters={handleSearchColumnFilters}
                toggleSider={toggleSider}
                collapseSider={collapseSider}
              />
            </ErrorBoundary> 
          </CardBody>
        </Card>
      </Container>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default Contracts;
